import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import FlashNewsFormLayer from "../components/FlashNewsFormLayer";

const FlashNewsFormPage = () => {
    return (
        <MasterLayout>
            <FlashNewsFormLayer />
        </MasterLayout>
    );
};

export default FlashNewsFormPage;
